<template>
  <div id="notifiBar"></div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'NotificationBar',
  data: () => ({}),
  created() {
    this.$center.notifications = this;
  },
  methods: {},
});
</script>

<style lang="scss">
@import '@/app/editor/scss/variables';

#notifiBar {
  text-align: left;
  position: absolute;
  z-index: 999999;
  top: 76px;
  left: 50%;
  max-width: 624px;
  min-width: 352px;
  min-height: 56px;
  border-radius: 3px;
  transform: translateX(-35%);
  overflow: hidden;
  display: none;
  svg {
    display: inline;
    vertical-align: unset;
  }

  .notifi {
    width: 100%;
    min-height: 54px;
    height: auto;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: start;
    padding-left: 16px;
    font-size: 14px;
    transition: all 0.3s;
    border-radius: 3px;
    padding: 16px;

    span {
      max-width: 472px;
      line-height: 22px;
      font-weight: 400;
      font-size: 14px;
      color: $textLightHigh;
      margin-right: 46px;
    }

    &.noti-success {
      background-color: #ccf4dd;

      > svg {
        fill: #00a042;
      }
    }

    &.noti-info {
      background-color: #d8e1ff;

      > svg {
        fill: #2856f8;
      }
    }

    &.noti-warning {
      background-color: #fdb913;

      > svg {
        fill: #494949;
      }
    }

    &.noti-error {
      background-color: #fee4e3;
      span {
        color: #f44336;
      }

      > svg {
        fill: #f44336;
      }
    }

    .close-notifi {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 22px;
      height: 22px;
      font-size: 16px;
      padding: 4px;
      position: absolute;
      right: 12px;
      line-height: 0;
      @include trans-all;
      &::before {
        content: '';
        background: #000000;
        position: absolute;
        border-radius: 3px;
        width: 100%;
        height: 100%;
        opacity: 0;
      }
      &:hover:before {
        opacity: 0.1;
      }
    }

    > svg {
      @include transform(translateY(0px));
      margin-right: 8px;
      width: 21px;
    }
  }
}
</style>
